import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import currentLang from '../../js/lib/currentLang';
import Debounce from '../../js/lib/debounce';

const staffDir = document.getElementById('StaffDirectory');

const options = {
	headers: {
		"content-type": "application/json; charset=utf-8"
	}
};

if(staffDir)
{
	const initUrl = envVar({
		backendPath: '/CrmDataPage/GetStaffDirectory?lang=' + currentLang(),
		staticPath: 'js/data/searchInit.json'
	});

	const rosterVue = new Vue({
		el: '#StaffDirectory',
		data: {
			staffDir: '',
			selected: '',
			input: '',
			loading: true,
		},
		watch: {
			// whenever input changes, this function will run
			input: function(newInput) {
				this.getPrompt();
			}
		},
		mounted: function() {
			const self = this;

			request().get(initUrl).then(function(response) {
				self.staffDir = response.listing;
                self.selected = response.listing;
                for (var x = 0; x < self.selected.length; x++) {
                    self.selected[x].users.sort(function (a, b) {
                        if (a.lastName < b.lastName)
                            return -1;
                        if (a.lastName > b.lastName)
                            return 1;
                        return 0;
                    });
                }
				self.loading = false;
			});
		},
		// Methods
		methods: {
			toggleNode: function(event) {
				const self = this;
				if (event.type === 'keypress' && event.keyCode === 13) {
					self.accordionToggle(event.currentTarget.parentElement);
				}
				// Or Click
				else if (event.type === 'click') {
					self.accordionToggle(event.currentTarget.parentElement);
				}
			},
			getPrompt: Debounce(function() {
				var self = this;

				if (self.input.length < 2) 	
				{
					self.selected = self.staffDir;

					// close all tabs
					const accordionTabs = document.querySelectorAll('.js-accordion-tab');

					for (var i = accordionTabs.length - 1; i >= 0; i--) 
						self.closeTab(accordionTabs[i].parentElement);
				}
				else
				{
					self.selected = [];

					var findMatch = new RegExp(self.input,"gi");
					for (var x = 0; x < self.staffDir.length; x++) 
					{
						// need to create a new instance of the object; can't just do var x = self.staffDir[x] (create a reference/pointer instead of copying obj)
						var tmpDir = { departmentName: self.staffDir[x].departmentName, users: [] };

						for (var y = 0; y < self.staffDir[x].users.length; y++) 
						{
							if(self.staffDir[x].users[y].firstName.match(findMatch))
								tmpDir.users.push(self.staffDir[x].users[y]);
							else if(self.staffDir[x].users[y].lastName.match(findMatch))
								tmpDir.users.push(self.staffDir[x].users[y]);
                        }

                        if (tmpDir.users.length > 0) {
                            self.selected.push(tmpDir);
                        }
					}

					// finally, open all accordians
					if(self.selected.length > 0)
					{
						const accordionTabs = document.querySelectorAll('.js-accordion-tab');

						for (var i = accordionTabs.length - 1; i >= 0; i--) 
							self.openTab(accordionTabs[i].parentElement);
					}
				}
			}, 500),

			// had to recreate this from /components/accordion.js; not ideal..
			// make a library someday..
			openTab: function(element) {
				const self = this;

				// if (!detectMobile() && element.closest('.js-accordion-mobile')) return;
				element.setAttribute('data-open', true);
				// Make button tabable
				if (element.querySelector('.button')){
					element.querySelector('.button').removeAttribute('tabindex');
				}
				// Accessibility
				element.removeAttribute('aria-hidden');
				element.setAttribute('aria-selected', true);
				
			},
			closeTab: function(element) {
				const self = this;

				element.removeAttribute('data-open');
				// Make button tabable
				if (element.querySelector('.button')) {
					element.querySelector('.button').setAttribute('tabindex', '-1');
				}
				// Accessibility
				element.removeAttribute('aria-selected');
				element.setAttribute('aria-hidden', true);
			},
			accordionToggle: function(thisTab) {
				const self = this;
				if (thisTab.getAttribute('data-open')) {
					self.closeTab(thisTab);
				}
				else {
					self.openTab(thisTab);
				}
				
			},
		}
	});
}



// WEBPACK FOOTER //
// ../components/staffdirectory/staffdirectory.js